export function getWebAuthnErrorMessage(error: any): string {
  const msg = (error?.message || String(error)).toLowerCase();
  const code = error?.code || (typeof error === 'object' && error !== null ? error.code : undefined);
  
  // Mapeo por código de error estructurado
  if (code) {
    switch (code) {
      case 'COUNTER_MISMATCH':
      case 'INVALID_COUNTER':
        return "Desajuste de seguridad detectado (el contador del dispositivo no coincide). Por favor, intenta de nuevo o usa tu contraseña.";
      case 'USER_VERIFICATION_REQUIRED':
        return "Se requiere verificación del usuario (PIN o biometría) pero no fue proporcionada o la configuración es incompatible.";
      case 'CONFIGURATION_INCOMPATIBLE':
        return "Configuración WebAuthn incompatible con el dispositivo. Por favor, revisa tus ajustes de seguridad.";
      case 'VERIFICATION_FAILED':
        return "La verificación de tu identidad falló. Asegúrate de usar el dispositivo correcto.";
      case 'CHALLENGE_NOT_FOUND':
        return "La sesión de autenticación ha caducado. Por favor, reintenta el acceso.";
      case 'CREDENTIAL_NOT_FOUND':
        return "Este dispositivo no está registrado en el sistema. Regístralo primero desde tu perfil.";
      case 'INTERNAL_ERROR':
        return "Error interno del servidor al procesar la huella.";
      default:
        break;
    }
  }

  // Mapeo por mensajes comunes del navegador
  if (msg.includes("notallowederror") || msg.includes("cancel") || msg.includes("aborted") || msg.includes("timeout") || msg.includes("timed out")) {
    return "Operación cancelada por el usuario o tiempo agotado.";
  }
  
  if (msg.includes("securityerror")) {
    return "Error de seguridad. Asegúrate de estar en un dominio seguro (HTTPS) y no en un marco (iframe).";
  }
  
  if (msg.includes("notsupportederror")) {
    return "Tu dispositivo o navegador no soporta esta funcionalidad de autenticación.";
  }
  
  if (msg.includes("invalidstateerror")) {
    return "Este dispositivo ya está registrado o la sesión es inválida.";
  }
  
  if (msg.includes("constrainterror")) {
    return "No se cumplen los requisitos del autenticador.";
  }

  if (msg.includes("publickey-credentials-create") || msg.includes("permissions policy")) {
    return "El acceso con huella no está permitido en este contexto (vista previa). Por favor, usa el dominio publicado.";
  }

  return "Ocurrió un error inesperado: " + msg;
}
